<template>
  <div class="grab-page">
    <div class="grab-nav">
      <van-icon name="wap-home-o" color="#fff" size="22" @click="$router.push('/Game')" />
      <div class="grab-title">{{ $t('auth.top44') }}</div>
      <van-icon name="service-o" color="#fff" size="22" @click="openKefu" />
    </div>

    <div class="grab-banner">
      <img class="banner-photo" src="/img/c1.png" alt="">
      <div class="banner-mask">
        <div class="banner-title">{{ $t('grab.banner') }}</div>
        <div class="banner-sub">{{ $t('grab.banner_sub') }}</div>
      </div>
    </div>

    <div class="grab-card">
      <div class="money">{{ home.money || '0.00' }}</div>
      <div class="money-label">{{ $t('grab.balance') }}</div>
    </div>

    <div class="stat-panel">
      <div class="stat-top">{{ rateText }}</div>
      <div class="stat-line"></div>
      <div class="stat-row">
        <div>
          <div class="num">{{ home.order_count || 0 }}</div>
          <div class="label">{{ $t('grab.order_count') }}</div>
        </div>
        <div>
          <div class="num">{{ home.done || 0 }}</div>
          <div class="label">{{ $t('grab.done') }}</div>
        </div>
        <div>
          <div class="num">{{ home.undone || 0 }}</div>
          <div class="label">{{ $t('grab.undone') }}</div>
        </div>
      </div>
    </div>

    <div class="earn-row">
      <div class="earn-card">
        <div class="earn-num">{{ home.total_commission || '0.00' }}</div>
        <div class="earn-label">{{ $t('grab.total_earn') }}</div>
      </div>
      <div class="earn-card">
        <div class="earn-num">{{ home.today_commission || '0.00' }}</div>
        <div class="earn-label">{{ $t('grab.today_earn') }}</div>
      </div>
    </div>

    <div class="start-btn" :class="{ off: finished || running }" @click="start">
      {{ finished ? $t('grab.finished_btn') : (running ? $t('grab.drawing') : $t('grab.start')) }}
    </div>
    <div class="history-link" @click="$router.push('/Bookinglist')">{{ $t('grab.history') }}</div>

    <div class="shot-wall">
      <div class="shot-head">{{ $t('grab.showcase') }}</div>
      <div class="shots">
        <div class="shot" v-for="item in shots" :key="item.id" @click="goMall">
          <img :src="item.pic" alt="">
          <div class="shot-name">{{ $t('shop.' + item.id) }}</div>
        </div>
      </div>
    </div>

    <div class="stage" v-if="stage" :class="{ 'lucky-stage': luckyFx }">
      <div class="glow"></div>
      <div class="lucky-fx" v-if="luckyFx">
        <div class="fx-flash"></div>
        <div class="fx-rays"></div>
        <div class="fx-ring"></div>
        <div class="fx-ring r2"></div>
        <div class="fx-ring r3"></div>
        <span class="spark" v-for="n in 20" :key="'s' + n" :style="sparkStyle(n)"></span>
        <span class="coin" v-for="n in 16" :key="'c' + n" :style="coinStyle(n)"></span>
        <div class="fx-card" v-if="order">
          <div class="fx-kicker">{{ $t('grab.lucky_hit') }}</div>
          <div class="fx-word">{{ $t('grab.lucky') }}</div>
          <div class="fx-price">{{ order.goods_price }}</div>
        </div>
      </div>
      <div class="stage-title">{{ showOrder ? $t('grab.got') : $t('grab.drawing') }}</div>
      <div class="reel-window" :class="{ dim: showOrder }">
        <div class="sprocket"></div>
        <div class="reel" :class="{ spin: spinning }">
          <div class="mini" v-for="(g, i) in reelItems" :key="i">
            <img v-if="g.pic" :src="g.pic" alt="">
            <div v-else class="ph"></div>
            <div class="mini-name">{{ g.name }}</div>
          </div>
        </div>
        <div class="sprocket"></div>
      </div>

      <transition name="ticket">
        <div class="ticket" :class="{ lucky: Number(order.is_lucky) === 1 }" v-if="showOrder && order">
          <div class="ticket-pic">
            <img v-if="order.goods_pic" :src="order.goods_pic" alt="">
          </div>
          <div class="perf"><i></i><i></i></div>
          <div class="ticket-body">
            <div class="ticket-name">
              <span class="lucky-tag" v-if="Number(order.is_lucky) === 1">{{ $t('grab.lucky') }}</span>
              {{ order.goods_name }}
            </div>
            <div class="ticket-row">
              <span>{{ $t('grab.price') }}</span>
              <b>{{ order.goods_price }}</b>
            </div>
            <div class="ticket-row hot">
              <span>{{ $t('grab.commission') }}</span>
              <b>{{ order.commission }}</b>
            </div>
            <div class="need-box" v-if="needRecharge">
              <div class="need-title">{{ $t('grab.lucky_need') }}</div>
              <div class="need-line">{{ $t('grab.lucky_hold', { money: order.money }) }}</div>
              <div class="need-line">{{ $t('grab.lucky_short', { amount: order.need_amount }) }}</div>
            </div>
            <div class="ticket-actions" v-if="needRecharge">
              <div class="btn gold wide" @click="goRecharge">{{ $t('grab.go_recharge') }}</div>
            </div>
            <div class="ticket-actions" v-else>
              <div class="btn ghost" @click="cancelOrder">{{ $t('grab.cancel') }}</div>
              <div class="btn solid" @click="tryGrab">{{ $t('grab.grab') }}</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { randomShopProducts } from '../choose/products';

export default {
  data() {
    return {
      home: {},
      kefu: '',
      stage: false,
      spinning: false,
      showOrder: false,
      order: null,
      grabbed: false,
      running: false,
      luckyFx: false,
      timer: null,
      revealTimer: null,
      luckyTimer: null,
      ticketTimer: null,
      shots: randomShopProducts(9),
    };
  },
  computed: {
    finished() {
      return Number(this.home.done) >= Number(this.home.order_count) && Number(this.home.order_count) > 0;
    },
    rateText() {
      return this.$t('grab.rate_orders', {
        rate: this.home.rate || '0.00',
        count: this.home.order_count || 0,
      });
    },
    needRecharge() {
      return this.order && Number(this.order.need_recharge) === 1;
    },
    reelItems() {
      let goods = Array.isArray(this.home.goods) ? this.home.goods.filter((g) => g && (g.pic || g.name) && Number(g.kind) !== 1 && String(g.name).indexOf('幸运订单') < 0) : [];
      if (!goods.length && this.order && Number(this.order.is_lucky) !== 1) {
        goods = [{ name: this.order.goods_name, pic: this.order.goods_pic, price: this.order.goods_price }];
      }
      if (!goods.length) goods = [{ name: '', pic: '', price: '' }];
      const loop = [];
      while (loop.length < 8) goods.forEach((g) => loop.push(g));
      return loop.concat(loop);
    },
  },
  watch: {
    stage(v) {
      document.body.style.overflow = v ? 'hidden' : '';
    },
  },
  methods: {
    openKefu() {
      if (this.kefu) window.location.href = this.kefu;
    },
    goMall() {
      this.$router.push('/Choose');
    },
    loadHome() {
      return this.$http({ method: 'get', url: 'grab_home' }).then((res) => {
        if (res.code === 200) this.home = res.data || {};
        else if (res.code === 401) this.tip(res.msg);
      });
    },
    loadConfig() {
      this.$http({ method: 'get', url: 'sys_config' }).then((res) => {
        if (res && res.data) this.kefu = res.data.kefu;
      });
    },
    start() {
      if (this.running || this.stage) return;
      if (Number(this.home.status) !== 1) {
        this.$toast(this.$t('grab.closed'));
        return;
      }
      if (Number(this.home.goods_count) < 1) {
        this.$toast(this.$t('grab.no_goods'));
        return;
      }
      if (this.finished) {
        this.$toast(this.$t('grab.finished'));
        return;
      }
      this.running = true;
      this.popNext(false);
    },
    coinStyle(n) {
      return {
        left: ((n * 37) % 92) + '%',
        width: (26 + (n % 3) * 12) + 'px',
        height: (26 + (n % 3) * 12) + 'px',
        animationDelay: ((n % 7) * 0.08) + 's',
        animationDuration: (1.55 + (n % 4) * 0.22) + 's',
      };
    },
    sparkStyle(n) {
      return {
        '--a': (n * 18) + 'deg',
        animationDelay: ((n % 6) * 0.045) + 's',
      };
    },
    playLucky() {
      this.luckyFx = true;
      clearTimeout(this.luckyTimer);
      this.luckyTimer = setTimeout(() => {
        this.luckyFx = false;
      }, 2800);
    },
    popNext(quick) {
      this.stage = true;
      this.spinning = true;
      this.showOrder = false;
      this.luckyFx = false;
      this.grabbed = false;
      clearTimeout(this.luckyTimer);
      clearTimeout(this.ticketTimer);
      const started = Date.now();
      const minSpin = quick ? 700 : 2200;
      this.$http({ method: 'post', url: 'grab_next' }).then((res) => {
        const wait = Math.max(quick ? 400 : 900, minSpin - (Date.now() - started));
        clearTimeout(this.revealTimer);
        this.revealTimer = setTimeout(() => {
          if (res.code === 200) {
            this.order = res.data;
            this.spinning = false;
            if (res.data.money) this.home.money = res.data.money;
            if (Number(res.data.is_lucky) === 1 && !Number(res.data.resume)) {
              this.playLucky();
              this.ticketTimer = setTimeout(() => {
                this.showOrder = true;
              }, 980);
              return;
            }
            this.showOrder = true;
            return;
          }
          this.stage = false;
          this.spinning = false;
          this.running = false;
          if (res.code === 201) {
            this.home = Object.assign({}, this.home, res.data || {});
            this.$toast(this.$t('grab.finished'));
          } else {
            this.tip(res.msg);
          }
        }, wait);
      }).catch(() => {
        this.stage = false;
        this.spinning = false;
        this.running = false;
        this.$toast(this.$t('grab.fail'));
      });
    },
    tryGrab() {
      if (this.needRecharge) {
        this.goRecharge();
        return;
      }
      this.finishOrder();
    },
    goRecharge() {
      sessionStorage.setItem('grab_wait_lucky', '1');
      this.$dialog.alert({ message: this.$t('recharge.contact_manager'), className: 'ban-tip-dialog', width: '84%' });
    },
    finishOrder() {
      if (!this.order || this.grabbed) return;
      if (this.needRecharge) {
        this.goRecharge();
        return;
      }
      this.grabbed = true;
      this.$http({ method: 'post', url: 'grab_finish', data: { id: this.order.id } }).then((res) => {
        if (res.code === 402) {
          this.order = Object.assign({}, this.order, res.data || {});
          this.grabbed = false;
          if (res.data && res.data.money) this.home.money = res.data.money;
          this.goRecharge();
          return;
        }
        if (res.code !== 200) {
          this.grabbed = false;
          this.tip(res.msg);
          return;
        }
        this.home = Object.assign({}, this.home, res.data || {});
        this.showOrder = false;
        this.luckyFx = false;
        this.order = null;
        if (Number(res.data.finished) === 1) {
          this.running = false;
          this.stage = false;
          this.spinning = false;
          this.$toast(this.$t('grab.paid_out'));
          return;
        }
        this.$toast(this.$t('grab.settled_later'));
        this.scheduleNext();
      }).catch(() => {
        this.grabbed = false;
        this.$toast(this.$t('grab.fail'));
      });
    },
    cancelOrder() {
      if (!this.order) return;
      this.$http({ method: 'post', url: 'grab_cancel', data: { id: this.order.id } }).then((res) => {
        this.showOrder = false;
        this.luckyFx = false;
        this.order = null;
        if (res.code !== 200) {
          this.running = false;
          this.stage = false;
          this.spinning = false;
          this.tip(res.msg);
          return;
        }
        if (res.data) this.home = Object.assign({}, this.home, res.data);
        this.scheduleNext();
      });
    },
    tip(msg) {
      const map = {
        '请先登录': 'grab.login',
        '抢单未开启': 'grab.closed',
        '抢单开启失败': 'grab.closed',
        '请先配置商品': 'grab.no_goods',
        '请先配置幸运订单商品': 'grab.no_lucky',
        '今日抢单已完成': 'grab.finished',
        '余额不足，无法抢单': 'grab.no_balance',
        '幸运订单余额不足，请充值': 'grab.lucky_need',
        '订单不存在': 'grab.fail',
        '订购失败': 'grab.fail',
      };
      this.$toast(map[msg] ? this.$t(map[msg]) : this.$t('grab.fail'));
    },
    scheduleNext() {
      clearTimeout(this.timer);
      this.spinning = true;
      const wait = 1000 + Math.floor(Math.random() * 4001);
      this.timer = setTimeout(() => {
        if (this.running) this.popNext(true);
      }, wait);
    },
  },
  created() {
    document.title = this.$t('auth.top44');
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
      return;
    }
    this.loadConfig();
    this.loadHome().then(() => {
      if (sessionStorage.getItem('grab_wait_lucky') === '1' && !this.finished) {
        sessionStorage.removeItem('grab_wait_lucky');
        this.running = true;
        this.popNext(true);
      }
    });
  },
  beforeDestroy() {
    clearTimeout(this.timer);
    clearTimeout(this.revealTimer);
    clearTimeout(this.luckyTimer);
    clearTimeout(this.ticketTimer);
    this.running = false;
    document.body.style.overflow = '';
  },
};
</script>

<style scoped>
.grab-page {
  min-height: 100vh;
  background: #f4f5f8;
  padding-bottom: 80px;
}
.grab-nav {
  height: 100px;
  background: linear-gradient(90deg, #5b21b6, #db2777);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 36px;
}
.grab-title { font-size: 36px; font-weight: 600; }
.grab-banner {
  margin: 36px 32px 0;
  height: 300px;
  border-radius: 36px;
  overflow: hidden;
  position: relative;
  color: #fff;
}
.banner-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.banner-mask {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: linear-gradient(120deg, rgba(255,77,141,.72), rgba(122,60,255,.62));
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 48px 48px 0;
  box-sizing: border-box;
}
.banner-title { font-size: 52px; font-weight: 700; line-height: 1.2; }
.banner-sub { margin-top: 16px; font-size: 28px; opacity: 0.92; }
.shot-wall {
  margin: 48px 32px 0;
}
.shot-head {
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  color: #5b21b6;
  margin-bottom: 24px;
}
.shots {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
}
.shot {
  width: 33.33%;
  padding: 6px;
  box-sizing: border-box;
}
.shot img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  display: block;
  background: #f3f0f6;
}
.shot-name {
  margin-top: 8px;
  font-size: 22px;
  color: #444;
  line-height: 1.35;
  height: 60px;
  overflow: hidden;
}
.grab-card {
  margin: -88px 56px 0;
  background: #fff;
  border-radius: 28px;
  text-align: center;
  padding: 40px 24px 36px;
  box-shadow: 0 16px 40px rgba(122, 60, 255, 0.12);
  position: relative;
}
.money { font-size: 72px; font-weight: 800; color: #222; line-height: 1.15; }
.money-label { color: #8a8a8a; font-size: 28px; margin-top: 12px; }
.stat-panel {
  margin: 40px 32px 0;
  border-radius: 28px;
  overflow: hidden;
  background: linear-gradient(90deg, #6a35e0, #b14bff);
  color: #fff;
}
.stat-top {
  text-align: center;
  padding: 32px 24px 0;
  font-size: 28px;
  line-height: 1.4;
}
.stat-line {
  height: 1px;
  margin: 24px 40px 0;
  background: rgba(255, 255, 255, 0.28);
}
.stat-row { display: flex; text-align: center; padding: 32px 0 40px; }
.stat-row > div { flex: 1; }
.stat-row .num { font-size: 48px; font-weight: 700; line-height: 1.2; }
.stat-row .label { font-size: 26px; opacity: 0.92; margin-top: 12px; }
.earn-row {
  margin: 32px 32px 0;
  display: flex;
  justify-content: space-between;
}
.earn-card {
  width: 48%;
  background: #fff;
  border-radius: 24px;
  text-align: center;
  padding: 28px 12px;
  box-sizing: border-box;
}
.earn-num { font-weight: 700; color: #222; font-size: 36px; line-height: 1.2; }
.earn-label { color: #8a8a8a; font-size: 26px; margin-top: 10px; }
.start-btn {
  margin: 48px 32px 0;
  height: 100px;
  line-height: 100px;
  text-align: center;
  color: #fff;
  border-radius: 50px;
  background: linear-gradient(90deg, #7c3aed, #db2777);
  font-size: 34px;
  font-weight: 700;
  box-shadow: 0 16px 32px rgba(124, 58, 237, 0.35);
}
.start-btn.off {
  background: #c5c6ce;
  color: #fff;
  box-shadow: none;
}
.history-link { text-align: center; color: #888; margin-top: 32px; font-size: 28px; }

.stage {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 40;
  background: radial-gradient(circle at 50% 18%, #4c1d95 0%, #14081f 58%, #09060f 100%);
  overflow: hidden;
}
.glow {
  position: absolute;
  left: 50%;
  top: 18%;
  width: 520px;
  height: 520px;
  margin-left: -260px;
  border-radius: 50%;
  background: rgba(244, 114, 182, 0.28);
  filter: blur(8px);
}
.stage-title {
  position: relative;
  z-index: 2;
  margin-top: 80px;
  text-align: center;
  color: #fff;
  font-size: 40px;
  font-weight: 700;
  letter-spacing: 2px;
}
.reel-window {
  position: relative;
  z-index: 2;
  margin-top: 48px;
  overflow: hidden;
}
.reel-window.dim { opacity: 0.28; }
.sprocket {
  height: 28px;
  background-color: #1b1028;
  background-image: radial-gradient(circle, #0b0612 7px, transparent 8px);
  background-size: 44px 28px;
  background-position: center;
}
.reel {
  display: flex;
  width: max-content;
  padding: 18px 0;
}
.reel.spin { animation: reel-move 4.8s linear infinite; }
.mini {
  width: 280px;
  margin-right: 24px;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  flex: none;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.28);
}
.mini img, .mini .ph { width: 280px; height: 180px; object-fit: cover; display: block; background: #efe7ff; }
.mini-name {
  height: 64px;
  line-height: 64px;
  padding: 0 16px;
  font-size: 24px;
  color: #222;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.lucky-stage .glow {
  background: rgba(255, 196, 60, 0.42);
  width: 760px;
  height: 760px;
  margin-left: -380px;
}
.lucky-fx {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 6;
  overflow: hidden;
  pointer-events: none;
  animation: fx-fade 2.8s linear both;
}
.fx-flash {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 38%, #fff8dc 0%, rgba(255, 196, 40, 0.72) 24%, rgba(20, 8, 31, 0) 68%);
  animation: flash 0.72s ease-out both;
}
.fx-rays {
  position: absolute;
  left: 50%;
  top: 38%;
  width: 980px;
  height: 980px;
  margin: -490px 0 0 -490px;
  background: repeating-conic-gradient(from 0deg, rgba(255, 214, 90, 0) 0 10deg, rgba(255, 220, 120, 0.42) 10deg 16deg);
  mix-blend-mode: screen;
  animation: spinrays 2.4s linear both;
}
.fx-ring {
  position: absolute;
  left: 50%;
  top: 38%;
  width: 180px;
  height: 180px;
  margin: -90px 0 0 -90px;
  border-radius: 50%;
  border: 10px solid rgba(255, 220, 110, 0.95);
  animation: ring 1.05s ease-out both;
}
.fx-ring.r2 { animation-delay: 0.16s; border-color: rgba(255, 77, 140, 0.85); }
.fx-ring.r3 { animation-delay: 0.32s; border-color: rgba(255, 255, 255, 0.8); }
.spark {
  position: absolute;
  left: 50%;
  top: 38%;
  width: 8px;
  height: 90px;
  margin-left: -4px;
  border-radius: 8px;
  background: linear-gradient(#fff, #ffd45a, rgba(255, 77, 140, 0));
  transform-origin: center top;
  animation: shoot 0.95s ease-out both;
}
.coin {
  position: absolute;
  top: -90px;
  border-radius: 50%;
  background: radial-gradient(circle at 35% 30%, #fff6c2, #ffc107 46%, #d97706);
  box-shadow: inset 0 -8px 0 rgba(146, 64, 14, 0.35);
  animation-name: coin-fall;
  animation-timing-function: linear;
  animation-fill-mode: both;
}
.coin::after {
  content: "★";
  display: block;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 1.05;
  color: #b45309;
  font-size: 22px;
  font-weight: 800;
}
.fx-card {
  position: absolute;
  left: 24px;
  right: 24px;
  top: 26%;
  text-align: center;
  animation: slam 0.62s cubic-bezier(0.15, 1.5, 0.3, 1) both, card-out 0.38s ease 1.55s forwards;
}
.fx-kicker {
  color: #ffe08a;
  font-size: 30px;
  font-weight: 700;
  letter-spacing: 10px;
}
.fx-word {
  margin-top: 8px;
  font-size: 96px;
  font-weight: 900;
  line-height: 1.05;
  background: linear-gradient(180deg, #fff8dc 0%, #ffd60a 46%, #ff4d6d 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0 10px 0 rgba(120, 20, 40, 0.28));
}
.fx-price {
  margin-top: 12px;
  color: #fff;
  font-size: 64px;
  font-weight: 800;
  text-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
}
.ticket {
  position: absolute;
  z-index: 3;
  left: 55px;
  right: 55px;
  top: 250px;
  background: #fffdf8;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 30px 70px rgba(0, 0, 0, 0.45);
}
.ticket.lucky {
  box-shadow: 0 0 0 8px rgba(255, 208, 64, 0.95), 0 0 48px rgba(255, 180, 40, 0.85), 0 30px 70px rgba(0, 0, 0, 0.45);
}
.ticket.lucky.ticket-enter-active {
  animation: ticket-in 0.55s cubic-bezier(0.18, 1.35, 0.4, 1) both, lucky-glow 1.4s ease-in-out 0.55s 2;
}
.ticket-pic { height: 360px; background: #f3e9ff; }
.ticket-pic img { width: 100%; height: 360px; object-fit: cover; display: block; }
.perf {
  position: relative;
  height: 36px;
  background: #fffdf8;
}
.perf::before {
  content: "";
  position: absolute;
  left: 28px;
  right: 28px;
  top: 16px;
  border-top: 4px dashed #e4d3f5;
}
.perf i {
  position: absolute;
  top: -18px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #14081f;
}
.perf i:first-child { left: -18px; }
.perf i:last-child { right: -18px; }
.ticket-body { padding: 8px 36px 36px; }
.ticket-name {
  font-size: 36px;
  font-weight: 800;
  color: #221533;
  line-height: 1.35;
}
.lucky-tag {
  display: inline-block;
  margin-right: 12px;
  padding: 4px 16px;
  border-radius: 20px;
  background: linear-gradient(90deg, #f59e0b, #ef4444);
  color: #fff;
  font-size: 22px;
  vertical-align: middle;
}
.ticket-row {
  margin-top: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #666;
  font-size: 28px;
}
.ticket-row b { color: #222; font-size: 32px; }
.ticket-row.hot b { color: #db2777; }
.ticket-actions { display: flex; margin-top: 32px; }
.btn {
  flex: 1;
  height: 88px;
  line-height: 88px;
  text-align: center;
  border-radius: 44px;
  font-weight: 700;
  font-size: 32px;
}
.btn.ghost { background: #f1eef6; color: #666; margin-right: 20px; }
.btn.solid { background: linear-gradient(90deg, #7c3aed, #db2777); color: #fff; }
.btn.gold { background: linear-gradient(90deg, #f59e0b, #ef4444); color: #fff; }
.btn.wide { width: 100%; }
.need-box {
  margin-top: 24px;
  padding: 24px;
  border-radius: 20px;
  background: linear-gradient(180deg, #fff7ed, #ffedd5);
  color: #9a3412;
  font-size: 26px;
  line-height: 1.5;
}
.need-title { font-size: 30px; font-weight: 800; color: #c2410c; }
.need-line { margin-top: 8px; }
.need-line b { color: #9a3412; }
.ticket-enter-active { animation: ticket-in 0.55s cubic-bezier(0.18, 1.35, 0.4, 1) both; }
@keyframes reel-move {
  from { transform: translate3d(0, 0, 0); }
  to { transform: translate3d(-50%, 0, 0); }
}
@keyframes ticket-in {
  0% { opacity: 0; transform: translateY(120px) scale(0.72) rotate(-8deg); }
  100% { opacity: 1; transform: none; }
}
@keyframes flash {
  0% { opacity: 0; }
  18% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes spinrays {
  from { transform: rotate(0deg) scale(0.55); opacity: 0.2; }
  20% { opacity: 1; }
  to { transform: rotate(70deg) scale(1); opacity: 0; }
}
@keyframes ring {
  0% { transform: scale(0.15); opacity: 1; }
  100% { transform: scale(7); opacity: 0; }
}
@keyframes shoot {
  0% { opacity: 1; transform: rotate(var(--a)) translateY(0) scaleY(0.15); }
  100% { opacity: 0; transform: rotate(var(--a)) translateY(340px) scaleY(1); }
}
@keyframes coin-fall {
  0% { transform: translateY(-20px) rotate(0deg); opacity: 1; }
  100% { transform: translateY(1500px) rotate(520deg); opacity: 0; }
}
@keyframes slam {
  0% { opacity: 0; transform: scale(0.2) rotate(-8deg); }
  100% { opacity: 1; transform: none; }
}
@keyframes card-out {
  to { opacity: 0; transform: scale(1.18) translateY(-40px); }
}
@keyframes fx-fade {
  0%, 78% { opacity: 1; }
  100% { opacity: 0; }
}
@keyframes lucky-glow {
  0%, 100% { box-shadow: 0 0 0 8px rgba(255, 208, 64, 0.95), 0 0 48px rgba(255, 180, 40, 0.85), 0 30px 70px rgba(0, 0, 0, 0.45); }
  50% { box-shadow: 0 0 0 14px rgba(255, 77, 140, 0.7), 0 0 80px rgba(255, 208, 64, 1), 0 30px 70px rgba(0, 0, 0, 0.45); }
}
</style>
